import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { DetailSubsection } from './DetailSubsection';
import { FeatureBoundary } from '@ui/features';
import { FeatureFlag } from '@sonar-software/sonar-core';
import React from 'react';
import { useSonarObjectReference } from '@hooks';
import { When } from 'react-if';
import { AppList, NotMonitoredLabel } from '@ui/applications';
export const PopulatedBySection = ({ sonarObjectId }) => {
    const { populatedBy } = useSonarObjectReference(sonarObjectId);
    const notMonitored = populatedBy.length === 1 && populatedBy[0] === -1;
    return (React.createElement(FeatureBoundary, { feature: FeatureFlag.DataSecurityDashboard },
        React.createElement(DetailSubsection, { className: 'inline-metadata', count: notMonitored ? 0 : populatedBy.length, title: COPY_SPECIFIC.POPULATED_BY, titleExtra: React.createElement(When, { condition: notMonitored },
                React.createElement(NotMonitoredLabel, null)) },
            React.createElement(When, { condition: !notMonitored },
                React.createElement(AppList, { appIds: populatedBy, direction: 'horizontal' })))));
};
